module.exports = {
  // Botium Events
  CONTAINER_BUILDING: 'CONTAINER_BUILDING',
  CONTAINER_BUILT: 'CONTAINER_BUILT',
  CONTAINER_BUILD_ERROR: 'CONTAINER_BUILD_ERROR',
  CONTAINER_STARTING: 'CONTAINER_STARTING',
  CONTAINER_STARTED: 'CONTAINER_STARTED',
  CONTAINER_START_ERROR: 'CONTAINER_START_ERROR',
  CONTAINER_STOPPING: 'CONTAINER_STOPPING',
  CONTAINER_STOPPED: 'CONTAINER_STOPPED',
  CONTAINER_STOP_ERROR: 'CONTAINER_STOP_ERROR',
  CONTAINER_CLEANING: 'CONTAINER_CLEANING',
  CONTAINER_CLEANED: 'CONTAINER_CLEANED',
  CONTAINER_CLEAN_ERROR: 'CONTAINER_CLEAN_ERROR',
  BOT_CONNECTED: 'BOT_CONNECTED',
  // Chatbot Events
  MESSAGE_SENTTOBOT: 'MESSAGE_SENTTOBOT',
  MESSAGE_SENDTOBOT_ERROR: 'MESSAGE_SENDTOBOT_ERROR',
  MESSAGE_RECEIVEDFROMBOT: 'MESSAGE_RECEIVEDFROMBOT',
  MESSAGE_RECEIVEFROMBOT_ERROR: 'MESSAGE_RECEIVEFROMBOT_ERROR',
  MESSAGE_ATTACHMENT: 'MESSAGE_ATTACHMENT',
  MESSAGE_TRANSCRIPT: 'MESSAGE_TRANSCRIPT',
  // Botium Agent Events
  TOOMUCHWORKERS_ERROR: 'TOOMUCHWORKERS_ERROR'
}
